export default class AuthStorage
{
    /**
     * @param {Storage} storage
     */
    constructor(storage) {
        this.storage = storage;
    }

    /**
     * @param {string} secret
     */
    putSecret(secret) {
        this.storage.setItem('userKey', secret);
    }

    /**
     * @return {string|undefined}
     */
    getSecret() {
        return this.storage.getItem('userKey');
    }

    /**
     * @param {string} email
     */
    putEmail(email) {
        this.storage.setItem('userEmail', email);
    }

    /**
     * @return {string|undefined}
     */
    getEmail() {
        return this.storage.getItem('userEmail');
    }

    /**
     * @return {boolean}
     */
    hasRefreshData() {
        return this.getSecret() && this.getEmail();
    }

    forgetAll() {
        this.storage.removeItem('userEmail');
        this.storage.removeItem('userKey');
    }
}
